import { Component, EventEmitter, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';

@Component({
    selector: 'app-configure-icon-button',
    templateUrl: './configure-icon-button.component.html',
    standalone: false
})
export class ConfigureIconButtonComponent extends AppBaseComponent {
  @Output() triggered = new EventEmitter<void>();

  onClick(event: Event): void {
    event.stopPropagation();
    this.triggered.emit();
  }
}
